export default __webpack_public_path__ + "static/media/156.58fbc839.svg";